import axios from "axios";
import {
  clearAuth,
  getStoredToken,
  hasValidSession,
  markSessionExpired,
} from "../services/authService";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://api.nayrahenna.com";

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    const token = getStoredToken();

    if (!token) {
      return config;
    }

    if (!hasValidSession()) {
      clearAuth();
      markSessionExpired();

      if (window.location.pathname !== "/") {
        window.location.replace("/");
      }

      return config;
    }

    config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const hadToken = Boolean(getStoredToken());

    if ((status === 401 || status === 403) && hadToken) {
      clearAuth();
      markSessionExpired();

      if (window.location.pathname !== "/") {
        window.location.replace("/");
      }
    }

    const message =
      error?.response?.data?.message ||
      error?.message ||
      "Unexpected request error.";

    return Promise.reject(new Error(message));
  }
);

export { API_BASE_URL };
export default api;